(ns ui.crisp
  "Identifies the logged-in user in the Crisp chat widget of the Replicant
   pages, so that support conversations arrive with a verified email, the
   company name and the session data that support relies on.

   The legacy Reagent app did this in `storrito.authentication.crisp`.
   `/js/crisp.js` only loads the widget, it does not know the user.

   Crisp reads `CRISP_TOKEN_ID` when it starts a session. The widget is
   already loading when the page code runs, so the token is set first and
   then `session:reset` makes Crisp start a new session with it (the same
   order as the legacy app). Afterwards the email is set together with its
   HMAC signature from `/authentication/crisp`, which marks it as verified
   in the Crisp inbox."
  (:require [app.util.transit :as transit]))

(defonce ^:private identified?
  (atom false))

(defn- crisp-push!
  [command]
  (.push js/window.$crisp (clj->js command)))

(defn- data-value
  [value]
  (if (some? value)
    (str value)
    ""))

(defn- session-data
  [user-session cell-id]
  [["version" "V2"]
   ["domain" js/location.hostname]
   ["subscription-status" (data-value (:subscription-status user-session))]
   ["credits" (data-value (or (:credit-balance-formatted user-session)
                              (:credit-balance user-session)))]
   ["cell-id" (data-value cell-id)]
   ["organization-created-at" (data-value (:organization/created-at user-session))]
   ;; Clears data that the V1 system stored in older sessions:
   ["subscription" ""]
   ["subscription-quantity" ""]
   ["subscription-mrr" ""]
   ["subscription-email" ""]
   ["subscription-id" ""]
   ["user-eid" ""]
   ["story-post-balance" ""]
   ["newsletter-subscriber" ""]
   ["org-summary" ""]])

(defn- set-user-data!
  [user-session {:keys [crisp-signature cell-id]}]
  (set! js/window.CRISP_TOKEN_ID crisp-signature)
  (crisp-push! ["do" "session:reset"])
  (crisp-push! ["set" "user:email" [(:user/email user-session) crisp-signature]])
  (when-let [company (:organization/name user-session)]
    (crisp-push! ["set" "user:company" [company]]))
  (crisp-push! ["set" "session:data" [(session-data user-session cell-id)]]))

(defn- fetch-signature
  []
  (-> (js/fetch "/authentication/crisp"
                #js {:method "POST"
                     :headers #js {"Content-Type" "application/json"}})
      (.then (fn [response]
               (if (.-ok response)
                 (.text response)
                 (throw (js/Error. (str "Crisp signature request failed: "
                                        (.-status response)))))))
      (.then transit/transit-decode)))

(defn identify!
  "Identifies the user of the `:query/user-session` result in Crisp, once
   per page load. Does nothing on pages without the Crisp widget."
  [user-session]
  (when (and (exists? js/window.$crisp)
             (:user/email user-session)
             (compare-and-set! identified? false true))
    (-> (fetch-signature)
        (.then (fn [response]
                 (set-user-data! user-session response)))
        (.catch (fn [error]
                  (reset! identified? false)
                  (js/console.warn "Crisp identification failed:" error))))))
